export { default } from "./pricing-feature-component";
